import {useEffect, useState} from 'react'
import {QueryStatus, QueryStatusType} from 'src/types'
import {OperacionNotaEstructurada} from "../types/types";
import {HttpNotaEstructurada} from "../api/httpNotaEstructurada";

type UseOperacionResult<TOperacion> = {
  status: QueryStatusType
  operacion: TOperacion | undefined
}

export const useOperacionNotaEstructurada: (idOperacion: number) => UseOperacionResult<OperacionNotaEstructurada> = (idOperacion: number) => {
  const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
  const [operacion, setOperacion] = useState<OperacionNotaEstructurada>()

  useEffect(() => {
    setStatus(QueryStatus.Loading)

    HttpNotaEstructurada.get(idOperacion)
      .then(data => {
        setOperacion(data)
        setStatus(QueryStatus.Success)
      })
      .catch(() => setStatus(QueryStatus.Error))
  }, [idOperacion])

  return {status, operacion}
}
